import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { BaseMortgageApplicationComponent } from '../base-mortgage-application.component';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';

@Component({
  selector: 'boi-your-outgoings',
  templateUrl: './your-outgoings.page.html',
  styleUrls: ['./your-outgoings.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YourOutgoingsPage extends BaseMortgageApplicationComponent {
  constructor(
    protected mortgageApplicationStore: MortgageApplicationStore,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    super(mortgageApplicationStore);
  }
}
